const traducciones = {
  ca: {
    perQui: "Per a qui fas la consulta?",
    age: "Edat de la persona afectada",
    location: "Codi postal, municipi",
    email: "Correu electrònic",
    query: "Consulta",
    acceptPrivacy: "He llegit i accepto la Política de Protecció de Dades",
    acceptProfessionals: "Accepto que els professionals de Línia Verda gestionin la meva consulta mitjançant correu electrònic",
    submit: "Envia",
    obligatory: "Els camps marcats amb * són obligatoris.",
    description: "Escriu la teva consulta i en 24 hores de dilluns a divendres rebràs una resposta",
    alerts: {
      selectConsultant: "Per favor, selecciona per a qui fas la consulta",
      fillAllFields: "Per favor, omple tots els camps obligatoris",
      acceptPrivacy: "Has d'acceptar la Política de Protecció de Dades",
      success: "Consulta enviada correctament. Rebràs una resposta en 24 hores de dilluns a divendres.",
      error: "Hi ha hagut un error en enviar la consulta. Intenta-ho més tard."
    },
    agePlaceholder: "-- Selecciona un tram d'edat --",
    dataTableTitle: "Informació bàsica sobre protecció de dades personals",

    dataTable: {
      responsable: "Responsable del tractament",
      responsableValor: "FUNDACIÓ IPSS",
      finalitat: "Finalitat tractament",
      finalitatValor: "Gestionar la consulta o sol·licitud del servei Línia Verda.",
      legitimacio: "Legitimació",
      legitimacioValor: "Consentiment de la persona interessada. La persona interessada pot retirar el consentiment en qualsevol moment.",
      destinataris: "Destinataris",
      destinatarisValor: "No es contemplen comunicacions.",
      drets: "Drets",
      dretsValor: "Drets",

      dretsAccesTitol: "Accés",
      dretsAccesText:
        "Té dret a conèixer si a Fundació IPSS estem tractant les seves dades personals i a accedir a les mateixes.",

      dretsRectificacioTitol: "Rectificació",
      dretsRectificacioText:
        "Pot sol·licitar la modificació de les dades inexactes.",

      dretsSupressioTitol: "Supressió",
      dretsSupressioText:
        "Pot sol·licitar l’eliminació de les seves dades personals.",

      dretsLimitacioTitol: "Limitació",
      dretsLimitacioText:
        "En determinades circumstàncies previstes a l’article 18 del RGPD, pot sol·licitar la limitació del tractament de les seves dades: quan es comprovi la impugnació de l’exactitud de les dades; quan el tractament és lícit però s’oposi a la supressió de les seves dades; quan Fundació IPSS no necessiti el tractament de les seves dades però vostè les necessiti per a la defensa de reclamacions; quan s’hagi oposat al tractament de les seves dades pel compliment d’una missió d’interès públic o satisfacció d’un interès legítim, mentre verifiquem si els motius legítims pel tractament prevalen sobre els seus.",

      dretsOposicioTitol: "Oposició",
      dretsOposicioText:
        "Pot oposar-se al tractament de les seves dades.",

      dretsPortabilitatTitol: "Portabilitat",
      dretsPortabilitatText:
        "Pot rebre, en format electrònic, les dades personals que ens hagi facilitat i transmetre-les a un altre responsable.",

      dretsRetirarConsentimentTitol: "Retirar el consentiment",
      dretsRetirarConsentimentText:
        "Quan la licitud del tractament es basi en haver obtingut el seu consentiment, podrà retirar-lo en qualsevol moment.",

      exerciciDrets: "Com pot exercir aquests drets?",
      exerciciDretsText1:
          "Mitjançant un escrit adreçat a Fundació IPSS, C/ Laforja, 67, 4t. 2a. de 08021 Barcelona, a l’atenció del Delegat de Protecció de Dades o bé, per correu electrònic a l’adreça dpd@ipss-online.org.",
      exerciciDretsText2:
          "Per exercir els seus drets acompanyi a la seva sol·licitud una còpia del DNI o document acreditatiu de la seva identitat. L’exercici dels seus drets és gratuït.",
        
      infoAddicional: "Informació addicional",
      infoAddicionalValor:
        "Pot consultar la informació addicional i detallada sobre protecció de dades de la Fundació IPSS a la web",
      infoAddicionalLink: "https://www.ipss-online.org/",
      colaboracio: "Amb la col·laboració de:",
      gestiona: "Gestiona:"
    }
  },

  es: {
    perQui: "¿Para quién realizas la consulta?",
    age: "Edad de la persona afectada",
    location: "Código postal, municipio",
    email: "Correo electrónico",
    query: "Consulta",
    acceptPrivacy: "He leído y acepto la Política de Protección de Datos",
    acceptProfessionals: "Acepto que los profesionales de Línia Verda gestionen mi consulta por correo electrónico",
    submit: "Enviar",
    obligatory: "Los campos marcados con * son obligatorios.",
    description: "Escribe tu consulta y en 24 horas de lunes a viernes recibirás una respuesta",
    alerts: {
      selectConsultant: "Por favor, selecciona para quién realizas la consulta",
      fillAllFields: "Por favor, completa todos los campos obligatorios",
      acceptPrivacy: "Debes aceptar la Política de Protección de Datos",
      success: "Consulta enviada correctamente. Recibirás una respuesta en 24 horas de lunes a viernes.",
      error: "Hubo un error al enviar la consulta. Inténtalo más tarde."
    },
    agePlaceholder: "-- Selecciona un rango de edad --",
    dataTableTitle: "Información básica sobre protección de datos personales",

    dataTable: {
      responsable: "Responsable del tratamiento",
      responsableValor: "FUNDACIÓ IPSS",
      finalitat: "Finalidad del tratamiento",
      finalitatValor: "Gestionar la consulta o solicitud del servicio Línia Verda.",
      legitimacio: "Legitimación",
      legitimacioValor:
        "Consentimiento de la persona interesada. La persona interesada puede retirar el consentimiento en cualquier momento.",
      destinataris: "Destinatarios",
      destinatarisValor: "No se contemplan comunicaciones.",
      drets: "Derechos",
      dretsValor: "Derechos",

      /* 🔹 DRETS – ES */
      dretsAccesTitol: "Acceso",
      dretsAccesText:
        "Tiene derecho a conocer si en la Fundació IPSS estamos tratando sus datos personales y a acceder a los mismos.",

      dretsRectificacioTitol: "Rectificación",
      dretsRectificacioText:
        "Puede solicitar la modificación de los datos inexactos.",

      dretsSupressioTitol: "Supresión",
      dretsSupressioText:
        "Puede solicitar la eliminación de sus datos personales.",

      dretsLimitacioTitol: "Limitación",
      dretsLimitacioText:
        "En determinadas circunstancias previstas en el artículo 18 del RGPD, puede solicitar la limitación del tratamiento de sus datos: cuando se impugne la exactitud de los datos; cuando el tratamiento sea lícito pero se oponga a la supresión de sus datos; cuando la Fundació IPSS no necesite tratar sus datos pero usted los necesite para la formulación, el ejercicio o la defensa de reclamaciones; o cuando se haya opuesto al tratamiento de sus datos por el cumplimiento de una misión de interés público o por la satisfacción de un interés legítimo, mientras verificamos si los motivos legítimos prevalecen sobre los suyos.",

      dretsOposicioTitol: "Oposición",
      dretsOposicioText:
        "Puede oponerse al tratamiento de sus datos.",

      dretsPortabilitatTitol: "Portabilidad",
      dretsPortabilitatText:
        "Puede recibir, en formato electrónico, los datos personales que nos haya facilitado y transmitirlos a otro responsable.",

      dretsRetirarConsentimentTitol: "Retirar el consentimiento",
      dretsRetirarConsentimentText:
        "Cuando la licitud del tratamiento se base en el consentimiento otorgado, podrá retirarlo en cualquier momento.",

      exerciciDrets: "¿Cómo puede ejercer estos derechos?",
      exerciciDretsText1:
        "Mediante un escrito dirigido a la Fundació IPSS, C/ Laforja, 67, 4º 2ª, 08021 Barcelona, a la atención del Delegado de Protección de Datos o bien, por correo electrónico a la dirección dpd@ipss-online.org.",
      exerciciDretsText2:
        "Para ejercer sus derechos deberá acompañar a su solicitud una copia del DNI u otro documento acreditativo de su identidad. El ejercicio de sus derechos es gratuito.",
      
      infoAddicional: "Información adicional",
      infoAddicionalValor:
        "Puede consultar la información adicional y detallada sobre protección de datos de la Fundació IPSS en la web",
      infoAddicionalLink: "https://www.ipss-online.org/",
      colaboracio: "Con la colaboración de:",
      gestiona: "Gestiona:"
    }
  }
};

export default traducciones;
